var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loadingProjectCategories)?_c('v-text-field',{attrs:{"color":"success","loading":"","disabled":""}}):_c('ProjectForm',{attrs:{"projectCategories":_vm.projectCategories,"projectData":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }